import type { DictionaryData } from './types';

function getDefaultValue(dictionaryData: DictionaryData) {
  if (Array.isArray(dictionaryData.value)) {
    return dictionaryData.value[0].value;
  }

  return dictionaryData.value;
}

export default getDefaultValue;
